import React from 'react';
import ProductListing from './ProductListing'
import ReactPlayer from 'react-player'
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';


var approvedSkincareSelectedVariant;

function areComplete(i) {
  return i.variantsSelected !== false;
}

function evalIfSoldOut(product){
	let finalCount = 0;
	product.variants.map((variant,i) => {
		if(variant.available){
			finalCount += 200
		}
	});
	if(finalCount <= 0){
		return true
	}else{
		return false
	}
}

class Skincare extends React.Component {

	constructor(props){
	    // Pass props to parent class
	    super(props);
	    // Set initial state
	    this.state = {
	      panel: 3,
	      sumbmitActive: false,
	      initialized: false,
	      cart: [],
	      prints: '',
	      quantities: [],
	      skincareMeta: this.props.meta[0],
	      videoOverlay: false
	    }

	    this.allPrintsSelected = this.allPrintsSelected.bind(this);
	    this.analyzeDataOnActivation = this.analyzeDataOnActivation.bind(this);
	    this.saveOverlayModification = this.saveOverlayModification.bind(this);
	    this.openOverlay = this.openOverlay.bind(this);
		this.evaluateProgressionButton = this.evaluateProgressionButton.bind(this);
		this.updateNonVariantOptionToCart = this.updateNonVariantOptionToCart.bind(this);
		this.checkIfAllVariantsSelected = this.checkIfAllVariantsSelected.bind(this);
		this.updateChildValue = this.updateChildValue.bind(this);
 		this.openVideoOverlay = this.openVideoOverlay.bind(this);
		this.closeVideoOverlay = this.closeVideoOverlay.bind(this);
		this.renderVideoIframe = this.renderVideoIframe.bind(this);
		this.evaluateProgressionButtonAccessibility = this.evaluateProgressionButtonAccessibility.bind(this);
 		this.openVideoOverlayAccessibility = this.openVideoOverlayAccessibility.bind(this);
 		this.closeVideoOverlay = this.closeVideoOverlay.bind(this);
		this.trapFocusKeydown = this.trapFocusKeydown.bind(this);
	}

	show(){
		let firstVideo = document.getElementsByClassName("skincare-content")[0].getElementsByClassName("video-overlay-toggle-collection-level");
		let firstProduct = document.getElementsByClassName("skincare-content")[0].getElementsByClassName("item")[0].getElementsByClassName("product-upper");

		if(firstVideo.length > 0){
			firstVideo[0].focus()
			firstVideo[0].blur();
		}else if(firstProduct){
			firstProduct[0].focus()
			firstProduct[0].blur();
		}
	}

	closeVideoOverlayAccessibility(e){
		if(e.which == 13 || e.keyCode == 13) {
			this.closeVideoOverlay(e);
		}
	}


	openVideoOverlayAccessibility(e, a){
		if(e.which == 13 || e.keyCode == 13) {
			this.openVideoOverlay(e,a);
		}
	}


	evaluateProgressionButtonAccessibility(e, a, b){
		if(e.which == 13 || e.keyCode == 13) {
			this.evaluateProgressionButton(e, a, b);
		}
	}


	openVideoOverlay(e, videoURL){
			
		this.setState({
			videoOverlayURL: videoURL
		}, () => {
			this.setState({
				videoOverlay: true
			});
			var navController = document.querySelector(".navigation");
			navController.classList.remove('active');
			var ele = document.getElementById('close-video-overlay-skincare');
			ele.focus();
		});
	}

	closeVideoOverlay(){
		this.setState({
			videoOverlay: false
		}, () => {
			this.setState({
				videoOverlayURL: ''
			});
			var navController = document.querySelector(".navigation");
			navController.classList.add('active');
			var ele = document.getElementById('video-close-skincare');
			ele.focus();
		});
	}

	renderVideoIframe(x){
		return <ReactPlayer controls="true" url={x} className="vimeo-wrapper-overlay" width="calc(98% - 40px)" height="52vw"/>
	}

	
	allPrintsSelected(){
		this.setState({
	    	sumbmitActive: true
	  	});
	}

	updateNonVariantOptionToCart(cartObj){
		let cart = [...this.state.cart]

		let evalCart = cart.map((productCart) => { 
			if (productCart.productID == cartObj.productID){
				productCart.cartObjects = cartObj.cartObject
				productCart.variantsSelected = true
			}
			return productCart;
		});

		let submitActive = evalCart.every(areComplete);

		this.setState({
			cart: evalCart
		}, () => {
			// this.productlisting.printsStateMessage();
			this.setState({
				sumbmitActive: submitActive
			});
		});	
	}

	checkIfAllVariantsSelected(quantityX, id){
		let allObjectsTotalQuantity = []
		var allInputValues = document.querySelectorAll(".skincare .preview-tile-quant");
		let cart = [...this.state.cart]
		let allIds = [];

		for (let item of allInputValues) {
			let elementValue = Number(item.value)
			let elementVariantID = item.getAttribute("id");
			let elementVariantQuantity = item.value
			let obj = {
				'id': elementVariantID,
				'value': elementVariantQuantity
			}
			allIds.push(obj);

		}

		let combinedValuesArray = [];

		let evalCart = cart.map((productCart, vlength) => { 
				allIds.map((product,i) => {
					let finalCount = 0;
					if (product.id == productCart.productID){

						productCart.cartObjects.map((variant,i) => {
							if(variant.quanitity > 0){
								finalCount += variant.quanitity
							}
						});
						if (product.id == id){
							if(quantityX == finalCount){
								productCart.variantsSelected = true
							}else{
								productCart.variantsSelected = false
							}
						}else if(productCart.hasOwnProperty("cartObjects") && productCart.cartObjects.length == 1){
							let cOid = productCart.cartObjects[0].id;
							let cOprice = productCart.cartObjects[0].price;
							let cOnewObject = {
								id: cOid,
								quanitity: parseInt(product.value),
								price: cOprice
							}
							productCart.cartObjects[0] = cOnewObject;
							productCart.variantsSelected = true
						}else if(finalCount != parseInt(product.value)){
							productCart.variantsSelected = false
						}else if(finalCount == parseInt(product.value) || parseInt(product.value) == 0 ){
							productCart.variantsSelected = true
						}else{
							productCart.variantsSelected = false
						}

					}
				});

				return productCart
		});

		let submitActive = evalCart.every(areComplete);

		this.setState({
			cart: evalCart
		}, () => {
			// this.productlisting.printsStateMessage();
			this.setState({
				sumbmitActive: submitActive
			});
		});	
	}

	updateChildValue(quantity, cart){
		this[`productlisting${cart.productID}`].updateQuantityFromParent(quantity, cart);
	}

	analyzeDataOnActivation(){
		if(this.state.initialized === false){
			approvedSkincareSelectedVariant = this.props.skincareProducts.map((product) => {
				var newProductObject = {}
				var soldOut = evalIfSoldOut(product)
				if(soldOut == true){
					newProductObject['productID'] = product.id
					newProductObject['variantsSelected'] = true
					newProductObject['cartObjects'] = []
				}else if (product.options.includes("Color")){
					newProductObject['productID'] = product.id
					newProductObject['variantsSelected'] = false
					newProductObject['cartObjects'] = []
				}else if ( product.variants.length == 1 ){
					newProductObject['productID'] = product.id
					newProductObject['variantsSelected'] = true
					newProductObject['cartObjects'] = [{
						id: product.variants[0].id,
						quanitity: product.meta.kitSuggestedQuantity,
						price: product.variants[0].price
					}]
				}else{
					newProductObject['productID'] = product.id
					newProductObject['variantsSelected'] = true
					newProductObject['cartObjects'] = [{
						id: product.variants[0].id,
						quanitity: 0,
						price: product.variants[0].price
					}]
				}
				return newProductObject
			});

			let submitActive = approvedSkincareSelectedVariant.every(areComplete);

			this.setState({
				cart: approvedSkincareSelectedVariant
			}, () => {
				this.checkIfAllVariantsSelected();
			});
		}else{
			// do nothing
		}
	}

	saveOverlayModification(quantity, cart, id){
		
		this.setState({
			panelActive: false
		}, () => {

			this.state.cart.map((product,i) => {

				if(cart.productID == product.productID){
					product.cartObjects = cart.cartObject
				}

			});

			this.updateChildValue(quantity, cart);
			this.checkIfAllVariantsSelected(quantity, id);
		
		});	

	}

	evaluateProgressionButton(e, cart, val){
		let cartObj = cart
	  	if (this.state.sumbmitActive === true){
  			this.props.addProductsToCart(cartObj, val)
  		}
	}

	openOverlay(product, qty, panel, event, maxQ){
		this.setState({
			panelActive: true
		}, () => {
			this.props.openOverlay(product, qty, panel, this.state.cart, event, maxQ)
		});
	}

	componentDidMount() {
  		document.addEventListener("keydown", this.trapFocusKeydown);
	}

	componentWillUnmount() {
 		 document.removeEventListener("keydown", this.trapFocusKeydown);
	}

	trapFocusKeydown(e) {
		if (!this.state.videoOverlay) return;

		const modal = document.querySelector('.skincare .lightbox-overlay.open.active');
		if (!modal) return;

		const focusableEls = modal.querySelectorAll(
			'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])'
		);

		const focusable = Array.prototype.slice.call(focusableEls);
		const firstEl = focusable[0];
		const lastEl = focusable[focusable.length - 1];

		if (e.key === "Tab" || e.keyCode === 9) {
			if (e.shiftKey) {
			if (document.activeElement === firstEl) {
				e.preventDefault();
				lastEl.focus();
			}
			} else {
			if (document.activeElement === lastEl) {
				e.preventDefault();
				firstEl.focus();
			}
			}
		}
	}

	render() {
    	return (
	    	<div className={(this.props.active ? 'active skincare' : 'skincare') + " " + (this.state.videoOverlay ? 'video' : '') + " " + (this.state.panelActive ? 'hide' : '')} id="panel">
	    		<div className="skincare-content">
					<div className="inner">
				 		<h1 tabindex="-1">Skincare</h1>
				 		{ this.state.skincareMeta.description != "" &&
						    <div dangerouslySetInnerHTML={{__html: ReactHtmlParser(this.state.skincareMeta.description)}}></div>
						}
						{ this.state.skincareMeta.link_url != "" &&
					    	<button id="video-close-skincare" className="video-overlay-toggle-collection-level" onClick={e => this.openVideoOverlay(e, this.state.skincareMeta.link_url)} onKeyPress={e => this.openVideoOverlayAccessibility(e, this.state.skincareMeta.link_url)}>
					    		{ this.state.skincareMeta.link_text != "" &&
					    			<span>{this.state.skincareMeta.link_text}</span>
					    		}
					    		{ this.state.skincareMeta.link_text == "" &&
					    			<span>Watch Video</span>
					    		}
					    	</button>
					    }
						
					</div>

					<ul className="product-grid">
						{
							this.props.skincareProducts.map((item,i) =>
								<ProductListing 
									ref={instance => (this[`productlisting${item.id}`] = instance)}
									item={item} 
									key={'skincare_' + i}
									quantities={this.state.quantities}
									suggestedQuantityOption={this.props.suggestedQuantityOption}
									panel={this.state.panel}
									updateNonVariantOptionToCart={this.updateNonVariantOptionToCart}
									checkIfAllVariantsSelected={this.checkIfAllVariantsSelected}
									openOverlay={this.openOverlay}
									cart={this.state.cart}
									lastItem={false}
								/>
							)
						}
					</ul>

					<button disabled={(this.state.sumbmitActive ? false : true)} className={(this.state.sumbmitActive ? 'progress-cta btn' : 'progress-cta inactive btn')} onClick={(e) => {this.evaluateProgressionButton( e, this.state.cart, 4 )}} onKeyPress={(e) => {this.evaluateProgressionButtonAccessibility( e, this.state.cart , 4 )}}>
				    Add to System
				    </button>
				</div>
				<div role="dialog" aria-modal="true" aria-label="Video tutorial for skincare" className={(this.state.videoOverlay ? 'open active lightbox-overlay' : ' lightbox-overlay')}>
					<button aria-label="Close Video Overlay" id="close-video-overlay-skincare" className="js-lightbox-close lightbox-close" onClick={e => this.closeVideoOverlay()} onKeyPress={e => this.closeVideoOverlayAccessibility(e)}><div><span></span></div></button>
				    {
				    	this.renderVideoIframe(this.state.videoOverlayURL)
				    }
					<div
						tabIndex={0}
						aria-live="polite"
						className="video-modal-end-trap"
					>
						<span className="inline">
							You are at the end of the video overlay. Use Tab to return to the close button or Shift + Tab to return to the video.
						</span>
					</div>
				</div>
			</div>
		)
	}
};

export default Skincare;